import React, { FunctionComponent } from "react"
import { Spinner } from "react-bootstrap"
import DynamicFormTypes from "src/pages/dynamic_forms/Types/DynamicFormsTypes"
import DynamicFormTaskTypes from "src/pages/dynamic_forms/Types/DynamicFormTaskTypes"
import taskManagerUtils from "../TaskManagerUtils/TaskManagerUtils"
import "./TaskManagerTaskModalHeader.css"

interface Props {
    workFlowId: number
    fetching: boolean
    saving: boolean
    showDebug: boolean
    manageParentState: Function
    backgroundColor: string
    headerTextColor: string
    inputTextColor: string
    viewItem?: {
        task: DynamicFormTaskTypes,
        form: DynamicFormTypes,
    }
}

const TaskManagerTaskModalHeader: FunctionComponent<Props> = (props) => {
    return (
        <div className="TaskManagerTaskModalHeader" style={{ color: props.headerTextColor }}>
            <div className="TaskManagerTaskModalHeaderLeft">
                <div className="TaskManagerTaskModalHeaderLeftItem">
                    <span className="material-icons">task</span>
                </div>
                <div className="TaskManagerTaskModalHeaderLeftItem">
                    {props.fetching && <p>Fetching</p>}
                </div>
                <div className="TaskManagerTaskModalHeaderLeftItem TaskManagerTaskModalHeaderLeftLastItem">
                    <p>{taskManagerUtils.lookupItem(`${props.workFlowId}`)[3]}</p>
                </div>
            </div>
            <div className="TaskManagerTaskModalHeaderRight">
                {props.saving && <div className="TaskManagerTaskModalHeaderRightSaving">
                    <Spinner id="task-manager-task-modal-header-right-saving" style={{ color: props.headerTextColor }} animation="border" />
                    <p style={{ color: props.inputTextColor }}>Saving form data...</p>
                </div>}
                {props.viewItem && !props.saving && <div className="TaskManagerTaskModalHeaderRightDebugInfo"
                    onMouseEnter={() => props.manageParentState([{ key: "showDebug", value: true }])}
                    onMouseLeave={() => props.manageParentState([{ key: "showDebug", value: false }])}
                >
                    <p style={{ color: props.showDebug ? props.inputTextColor : props.backgroundColor }}>
                        {`W-${props.viewItem.task.DynamicFormWorkFlowId}`}
                    </p>
                </div>}
            </div>
        </div>
    )
}

export default TaskManagerTaskModalHeader